import { isLength } from 'lodash';
import {
  observable,
  action,
  reaction,
  useStrict,
  runInAction,
  autorun,
  flow,
  toJS,
  computed
} from 'mobx';
import utils from 'utils';
import Serv from './RemindCustomerServ';

class RemindCustomerMod {
  // 团队类型枚举
  @observable teamTypeList = [
    { label: '全部', value: '' },
    { label: '销售团队', value: '1' },
    { label: '客户团队', value: '2' },
    { label: '跟进中团队', value: '3' }
  ];

  // 客户分群枚举
  @observable teamGroupList = [{ label: '全部', value: '' }];

  // 选中的团队类型值
  @observable teamType = '';

  // 选中的客户分群值
  @observable teamGroup = '';

  // 客户列表源 {'A': [], 'W': [], ...} 的形式
  @observable customersSource = {};

  // 初始选择的客户
  @observable initSelectedList = [];

  // 是否全选
  @observable selectedAll = false;

  /**
   * 团队类型筛选后的客户列表
   */
  @computed
  get customersMap() {
    if (!this.teamType) return this.customersSource;
    let customersMap = toJS(this.customersSource);
    for (let key in customersMap) {
      customersMap[key] = customersMap[key].filter((item) => item.team == this.teamType);
      if (customersMap[key].length == 0) delete customersMap[key];
    }
    return customersMap;
  }

  /**
   * 选择的团队类型
   */
  @computed
  get teamTypeObj() {
    return this.teamTypeList.find((item) => item.value == this.teamType);
  }

  /**
   * 选择的客户分组
   */
  @computed
  get teamGroupObj() {
    return this.teamGroupList.find((item) => item.value == this.teamGroup);
  }

  /**
   * 返回客户分组字母列表：['A', 'F', ..., 'W', '#']
   */
  @computed
  get headers() {
    return Object.keys(this.customersMap);
  }

  /**
   * 返回二维数组，记录索引（客户在第x字母的第x行的索引）
   * 如：[
   *      [0, 1, 2],
   *      [0, 1, 2, 3, 4, 5],
   *     ]
   */
  @computed
  get rowIndexs() {
    let rowIndexs = [];
    for (let item in this.customersMap) {
      rowIndexs[rowIndexs.length] = [...new Array(this.customersMap[item].length).keys()];
    }
    return rowIndexs;
  }

  /**
   * 客户总数
   */
  @computed
  get totalLength() {
    let total = 0;
    for (let key in this.customersMap) {
      total += this.customersMap[key].length;
    }
    return total;
  }

  /**
   * 已选客户数
   */
  @computed
  get selectedLength() {
    let total = 0;
    for (let key in this.customersSource) {
      this.customersSource[key].forEach((item) => {
        if (item.checked) total += 1;
      });
    }
    return total;
  }

  @action
  changeState(obj) {
    console.log(JSON.stringify(obj) + '打印这个点击选择团队的时候的样式');
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @action
  initSelect() {
    const list = this.initSelectedList;
    const customersMap = toJS(this.customersSource);
    if (!list.length) return;
    list.forEach((item) => {
      for (let key in customersMap) {
        let index = customersMap[key].findIndex((cust) => cust.userId == item.customerId);
        if (index >= 0) {
          customersMap[key][index].checked = true;
          break;
        }
      }
    });
    this.customersSource = customersMap;
  }

  @action
  selectCustomer = (group, index) => {
    let customersMap = toJS(this.customersSource);
    let customer = customersMap[group][index];
    customer.checked = !customer.checked;
    this.customersSource = customersMap;
  };

  getCustomerList = flow(function* () {
    try {
      this.customersSource = {};
      let params = {};
      // 团队分类参数
      if (this.teamType) {
        params.teamType = this.teamType;
      } else {
        // 团队分类为“全部时”，要加这个参数过滤潜客
        params.filterTeamType = 4;
      }
      // 客户分群参数
      if (this.teamGroup) params.tagIds = this.teamGroup;
      const { data } = yield Serv.getCustomerList(params);
      if (Array.isArray(data.list)) {
        let customersSource = {};
        data.list.forEach((item) => (customersSource[item.key] = item.data));
        this.customersSource = customersSource;
        this.initSelect();
      }
    } catch (error) {}
  });

  getTeamGroupList = flow(function* () {
    try {
      const { data } = yield Serv.getTeamGroupList();
      if (Array.isArray) {
        this.teamGroupList = [{ label: '全部', value: '' }].concat(
          data.map((item) => ({ label: item.name, value: item.id, ...item }))
        );
      }
    } catch (error) {}
  });
}
// const remindCustomerMod = new RemindCustomerMod();
export default RemindCustomerMod;



// WEBPACK FOOTER //
// ./src/pages/Promote/Schedule/NewAdd/RemindCustomer/RemindCustomerMod.js